import axios from "axios";
import { config } from "../config/config";

// axios default configs
axios.defaults.baseURL = config.serverBaseUrl2;
axios.defaults.timeout = 30000;

// 首页的图
export const getSpecPic = () =>
  axios.get(`/alipay_b_api/used_pic_all`);


// search by keywords
export const searchByKeywords = keywords =>
  axios.get(`/alipay/alipay_api_specs/${keywords}`);

// search by id
export const searchBySpecId = specificationID =>
  axios.get(`/alipay/alipay_api_specs_by_id/${specificationID}`);

// spec by id
export const specBySpecId = specificationID =>
  axios.get(`${config.serverBaseUrl3}/baidu_applet/baidu_applet_specs_by_id/${specificationID}`);

// can print?
export const canPrint = specificationID =>
  axios.get(`${config.serverBaseUrl3}/baidu_applet/baidu_applet_judge/${specificationID}`);

// make id photo
export const makeIdPhoto = (imageBase64, specificationID, userId) =>
  axios.post(`/alipay/new_alipay_cut_pic`, {
    file: imageBase64,
    spec_id: specificationID,
    user_id: userId
  });

//get openId
export const getOpenId = authCode =>
  axios.get(`/alipay/get_user_id?code=${authCode}`);

// request payment
export const requestPayment = (
  paymentType,
  orderId,
  openId,
  bgColor = 0,
  isUrgent = 0,
  printPhotoQty = 1,
	is_multicolor=null,
	is_beautiful=true
) =>{
	let url=`is_print=${paymentType}&back_number=${bgColor}&is_urgent=${isUrgent}&print_number=${printPhotoQty}`;
	if(is_multicolor){
		url+=`&is_multicolor=${is_multicolor}`
	}
	if(!is_beautiful){
		url+=`&is_beautiful=${!is_beautiful}`
	}
		return axios.get(
			`/alipay/alipay_pay/${orderId}/${openId}?${url}`
			// `/alipay/alipay_pay/${orderId}/${openId}?is_print=${paymentType}&back_number=${bgColor}&is_urgent=${isUrgent}&print_number=${printPhotoQty}&is_multicolor=${is_multicolor}`
		);
	}

// check payment status
export const checkPaymentStatus = orderId =>
  axios.get(`/alipay/alipay_pay_confirm/${orderId}`);

// check orderlists
export const checkOrderLists = userId =>
  axios.get(`/alipay/get_final_pic_alipay/${userId}`);

// check printorderlists
export const checkPrintOrderLists = userId =>
  axios.get(`/print/user/orders`,{
	headers:{
		'user-id':`${userId}`
	}
});

// check detail order information
export const checkDetailOrderInfo = orderId => axios.get();

// submit print order
export const submitPrintOrder = (
	specName,
  consigneeName,
  consigneePhone,
	detailAddr,
	user_id,
 	city,
  printPhotoQty,
  origin_pic_name,
	final_pic_name,
	print_pic_name,
	expressType,
) =>
  axios.post(`/print/gen_order`, {
  	description:specName,
    user_name: consigneeName,
    user_phone: consigneePhone,
		detail_address:detailAddr,
		user_id:user_id,
		division:city,
    quantity: printPhotoQty,
    origin_pic_name:origin_pic_name,
		final_pic_name:final_pic_name,
		print_pic_name:print_pic_name,
		delivery:expressType,
  });

//get custom service info
export const getServiceInfo = () =>
  axios.get(`${config.serverBaseUrl3}/baidu_applet/baidu_contact_service`);

//热搜
export const getHotSearch = () => axios.get("/alipay/alipay_life_applet_hot");

//首页弹窗
export const getMainNotify = () => axios.get("/alipay/alipay_life_applet_first_popup");

//冲印须知
export const getPrintNotify = () => axios.get("/alipay/alipay_life_applet_print_notify");

//获取价格
export const getPrice = () => axios.get(`/alipay/alipay_money_sum`);

//获取冲印价格
export const getPrintPrice = () => axios.get(`/print/price`);

//发送邮件到邮箱--电子订单
export const sendEMailEle = (
	email,orderId,userId
) =>  axios.get(`/alipay_b_api/send_email?email=${email}&order_id=${orderId}`,{ 
			headers:{
          "user-key":userId
        },
				})
//发送邮件到邮箱--冲印订单
export const sendEMailPrint = (
	email,printId,userId
) => axios.get(`/alipay_b_api/send_email?email=${email}&print_order_id=${printId}`,{ 
			headers:{
          "user-key":userId
        },
				})
